export default "__VITE_PUBLIC_ASSET__3f66e68b__"